module.exports = __webpack_public_path__ + "media/CN_011.3446cafe.mp3";